import { AccountAPI } from "./apiUtils";

// http://localhost:3000/api/consumable-logs-report?from_date=2021-05-22&to_date=2021-05-27&type=Solo

export const getConsumables = async ({ start_date, end_date, type }) =>
await AccountAPI.get(
  `/consumable-logs-report?from_date=${start_date}&to_date=${end_date}&type=${type}`
);